import React from 'react';

const Loading = ({ message = "Loading..." }) => {
  return (
    <div className="fixed top-4 right-4 z-[9999] bg-white/80 backdrop-blur-md px-4 py-2 rounded-2xl border border-slate-100 shadow-xl flex items-center gap-3 animate-in fade-in slide-in-from-right-4 duration-500">
      <div className="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
      <span className="text-[10px] font-black uppercase tracking-widest text-slate-900">{message}</span>
    </div>
  );
};

export default Loading;
